import { Button, MediaArt } from '../../components/ui'
import { useTenant } from '../../tenant/useTenant'

/**
 * E1 — vendor identity above the fold. The cover is a background layer rather
 * than an <img> so the copy card can sit on top of it at any viewport height,
 * and a vendor without a cover falls back to the drawn interior. The scrim sits
 * over both, so the copy card keeps the same contrast either way.
 */
export function HomeHero() {
  const { slug, bootstrap } = useTenant()
  const { vendor, theme } = bootstrap

  return (
    <section className="relative flex min-h-[600px] items-center justify-center overflow-hidden md:min-h-[720px]">
      {theme.cover ? (
        <div
          aria-hidden="true"
          className="absolute inset-0 h-full w-full bg-cover bg-center"
          style={{ backgroundImage: `url('${theme.cover}')` }}
        />
      ) : (
        <MediaArt kind="cover" className="absolute inset-0" />
      )}
      <div aria-hidden="true" className="absolute inset-0 bg-surface/40 backdrop-blur-[2px]" />

      <div className="container-page relative z-10">
        <div className="mx-auto max-w-3xl rounded-lg border border-primary/10 bg-surface/80 p-8 text-center shadow-sm backdrop-blur-xl md:p-12">
          <h1 className="mb-6 font-display text-headline-lg-mobile text-primary md:text-headline-lg">{vendor.name}</h1>
          {vendor.tagline && (
            <p className="mx-auto mb-8 max-w-xl font-body-lg text-body-lg text-on-surface-variant">{vendor.tagline}</p>
          )}
          <div className="flex flex-col justify-center gap-4 sm:flex-row">
            <Button to={`/${slug}/book`} size="lg">
              Book now
            </Button>
            <Button to={`/${slug}/services`} size="lg" variant="outlined">
              View services
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
